<div class="categories-wrapper w-full">
  <div class="close-wrapper flex justify-end">
    <app-icon (click)="closeButtonClickHandler()"
              class="cursor-pointer close-icon"
              svgIcon="cross"></app-icon>
  </div>
  <div class="category-heading flex justify-center font-semibold font-poppins">
    Add Categories
  </div>
  <div class="w-full flex justify-center flex-col items-center">
    <div class="flex flex-col w-full items-center justify-center">
      <div class="w-[90%]">
        <hr class="separator"/>
        <div class="w-full flex">
          <div class="w-[50%] font-work-sans font-semibold category-separator-heading">
            Category
          </div>
          <div class="w-[50%] font-work-sans font-semibold category-separator-heading">
            Subcategory
          </div>
        </div>
        <hr class="separator"/>
      </div>
    </div>
    <div *ngFor="let category of getCategoryForm(); let index = index"
         class="w-[90%]  category-wrapper">
      <div class="w-full flex items-center">
        <div class="md:w-[46.5%] sm:w-[44%]">
          <app-dropdown [enableClearSelection]="true"
                        [enableMultiple]="false"
                        [options]="categoriesDropDownOptions"
                        [parentFormGroup]="category"
                        class="resource-input"
                        controlName="name"
                        placeholder="Select Category"
                        type="small"/>
        </div>
        <div class="md:w-[46.5%] sm:w-[44%] subcategory-select">
          <app-dropdown [enableClearSelection]="true"
                        [enableMultiple]="true"
                        [loading]="getSubCategoriesLoading(category)"
                        [options]="getSubCategoriesOptions(category)"
                        [parentFormGroup]="category"
                        class="resource-input"
                        controlName="subCategories"
                        placeholder="Check all that apply"
                        type="small"/>
        </div>
        <div class="flex flex-row md:w-[7rem] sm:w-[12rem]">
          <app-icon (click)="removeCategory(index)"
                    *ngIf="getCategoryForm().length > index && getCategoryForm().length != 1"
                    [svgIcon]="'substract-bold'"
                    class="cursor-pointer add-category-icon"></app-icon>
          <app-icon (click)="addCategory(index)"
                    *ngIf="getCategoryForm().length === index+1"
                    [svgIcon]="'add-bold'"
                    class="cursor-pointer add-category-icon"></app-icon>
        </div>
      </div>
      <hr class="separator"/>
    </div>
    <div class="w-[95%] flex justify-end confirm-button-wrapper">
      <app-primary-button (click)="conformButtonClicked()"
                          [isDisabled]="isButtonDisabled"
                          [type]="'small'">
        Confirm
      </app-primary-button>
    </div>
  </div>
</div>
